module.exports = __webpack_public_path__ + "static/media/xmark.6ff15a4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/AudienceBuilder/assets/xmark.svg
// module id = 7641
// module chunks = 0